import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

import PrimaryButton from "../Buttons/PrimaryButton";
import SecondaryButton from "../Buttons/SecondaryButton";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AlertDialogSlide = ({
  open,
  onClose,
  title,
  children,
  actionLabel,
  onAction,
  cancelLabel = "Close",
  actionDisabled = false,
  disableClose = false,
}) => {
  const handleClose = (event, reason) => {
    if (disableClose) return;
    onClose?.(event, reason);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      role="alertdialog"
    >
      {title ? (
        <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
      ) : null}
      <DialogContent id="alert-dialog-slide-description">
        {children}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <SecondaryButton
          variant="outlined"
          onClick={handleClose}
          disabled={disableClose}
        >
          {cancelLabel}
        </SecondaryButton>
        {actionLabel ? (
          <PrimaryButton
            onClick={onAction}
            disabled={actionDisabled}
            autoFocus
          >
            {actionLabel}
          </PrimaryButton>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialogSlide;
